import { createCarouselSlice } from './createCarouselSlice'

/**
 * Redux slice for the "Previously purchased" recommendations carousel.
 * State shape and reducers come from `createCarouselSlice`.
 * @internal
 */
export const previouslyPurchasedSlice = createCarouselSlice(
  'previouslyPurchasedSlice',
)

export const {
  setItems: setPreviouslyPurchasedItems,
  setStatus: setPreviouslyPurchasedStatus,
} = previouslyPurchasedSlice.actions

export default previouslyPurchasedSlice.reducer
